import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router';
import FormSenderV2 from '../components/orderPage/formSender/FormSenderV2';
import useSetTags from '../hooks/useSetTags';

const CONFIG = {
  bg: {
    title: 'Поръчайте курса',
    description: 'Поръчайте курс eLingo с доставка до адрес чрез Speedy.',
  },
};

const OrderPageV2 = ({ data }) => {
  const { lang } = useParams();

  useSetTags(CONFIG);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    return () => meta.remove();
  }, []);

  if (lang !== 'bg') {
    return <Navigate to={`/${lang}/course`} replace />;
  }

  if (!data) return null;

  return (
    <div>
      <FormSenderV2 data={data.formControll} />
    </div>
  );
};

export default OrderPageV2;
